// @flow weak

import React from 'react';

const TodoListSeeAllTask = () => (
  <a
    className="btn btn-default btn-sm pull-right"
    href="#">
    See All Tasks
  </a>
);

export default TodoListSeeAllTask;



// WEBPACK FOOTER //
// ./src/app/components/todoList/todoListCommands/TodoListSeeAllTask.js